<template>
    <div>
        <v-card
            class="mx-auto pa-5 mt-5"
            style="max-width: 600px"
        >
            <ForgotPasswordForm/>
        </v-card>
    </div>
</template>

<script>
import GuestLayout from "../../Layouts/GuestLayout";
import ForgotPasswordForm from "../../components/Auth/Forms/ForgotPasswordForm.vue";

export default {
    name: "ForgotPassword",
    layout: [GuestLayout],
    components: {ForgotPasswordForm}
}
</script>

<style scoped>

</style>
